<article [attr.data-automation-id]="'instatouch-prefill-card'">
  <form (ngSubmit)="emitEvent(instaTouch)" #instaTouch="ngForm">
    <ng-container [ngSwitch]="currentStage">
      <!-- Autofill: Mobile initial number entry stages.initial-->
      <section *ngSwitchCase="stages.initial">
        <!-- HEADING -->
        <header class="bl-display-sm--flex bl-text-align--center bl-text-align--center bl-margin-bottom--16 bl-flex-direction--column">
          <ea-svg
            class="bl-text-align--center"
            [svgClass]="isCoapplicant ? 'instatouch-coapp-svg' : 'instatouch-mobile-svg'"
            [minWidth]="'42px'"
            [minHeight]="'42px'"
            [width]="'42px'"
            [height]="'42px'"
          >
          </ea-svg>
          <h2 class="bl-text-style--display-3 bl-margin--0 bl-text-align--center bl-padding-x-md--24">
            {{ getHeadingLabel('mobileHeader') }}
          </h2>
        </header>
        <p class="bl-text-style--default-text-1 bl-text-align--center bl-padding-x-md--24 bl-margin-bottom--24">{{ cardDescription }}</p>

        <!-- CONTENT -->
        <div id="content" class="bl-margin-y--40">
          <label class="bl-text-style--secondary-text-2 bl-margin-bottom--4 bl-required" for="mobileNumber">
            {{ getHeadingLabel('mobileNumberLabel') }}
          </label>
          <input
            class="bl-input bl-width--100"
            id="mobileNumber"
            data-automation-id="mobile-number"
            name="mobile"
            minlength="10"
            type="tel"
            inputmode="numeric"
            [(ngModel)]="mobileNumber"
            #mobile="ngModel"
            required
            [class.bl-error]="!validMobileNumber && instaTouch.touched"
            [class.bl-disabled]="lockMobileNumber || isLoading"
            [disabled]="lockMobileNumber || isLoading"
            aria-describedby="mobileNumberError"
            placeholder="(___) ___-____"
            mask="(000) 000-0000"
          />
          <p
            *ngIf="!validMobileNumber && instaTouch.touched"
            id="mobileNumberError"
            aria-live="polite"
            class="bl-error-msg bl-margin-top--4 bl-margin-bottom--0"
          >
            {{ 'personalInfoAutofill/mobileNumberError' | dictionary }}
          </p>
          <p
            *ngIf="validMobileNumber"
            aria-live="polite"
            class="bl-text-style--default-text-1 bl-margin-top--16 bl-margin-bottom--0 bl-text-align--center"
            [innerHTML]="disclaimer"
          ></p>
          <!-- Error alert -->
          <ea-alert
            [showAlert]="!!errorMessage"
            alertId="instatouch-get-passcode-alert"
            alertStatus="warning"
            [message]="errorMessage"
            [ngClass]="{ 'bl-display--block bl-margin-top--32 bl-max-width--tablet-width': errorMessage }"
          >
          </ea-alert>
        </div>

        <!-- CTA -->
        <ea-button-loader
          buttonType="button"
          buttonId="instatouch-get-passcode-button"
          buttonClass="bl-width--100 bl-margin-bottom--16"
          [text]="'personalInfoAutofill/continue' | dictionary"
          [loading]="isLoading"
          (event)="emitEvent(instaTouch)"
        >
        </ea-button-loader>
        <div class="bl-margin-x--auto bl-text-align--center" *ngIf="proceedWithoutPhone.observers?.length !== 0">
          <button
            type="button"
            class="bl-button bl-button-reverse bl-width--100"
            id="proceed-without-phone-pre-fill"
            (click)="proceedWithoutPhonePrefill()"
          >
            <span class="bl-white-space--normal">{{ 'personalInfoAutofill/skipPrefill' | dictionary }}</span>
          </button>
          <p class="bl-text-style--default-text-1 bl-margin-top--8 bl-margin-bottom--0">
            {{ 'personalInfoAutofill/Offramp' | dictionary }}
          </p>
        </div>
      </section>

      <!-- Autofill: Confirm passcode-->
      <section *ngSwitchCase="stages.passcode">
        <!-- HEADING -->
        <header
          class="bl-display-sm--flex bl-flex-direction--column bl-text-align--center bl-text-align-sm--left bl-align-items--center bl-margin-bottom--16"
        >
          <ea-svg
            class="bl-text-align--center"
            svgClass="instatouch-mobile-svg"
            [minWidth]="'42px'"
            [minHeight]="'42px'"
            [width]="'42px'"
            [height]="'42px'"
          >
          </ea-svg>
          <h2 class="bl-text-style--display-3 bl-margin--0 bl-text-align--center bl-padding-x--24">
            {{ 'personalInfoAutofill/codeSent' | dictionary }}
          </h2>
        </header>

        <!-- CONTENT -->
        <div id="content" class="bl-margin-y--40">
          <p
            *ngIf="getMobileNumberWithAsterisks(mobileNumber)"
            class="bl-text-style--default-text-1 bl-margin-bottom--16 bl-text-align--center"
          >
            {{ 'personalInfoAutofill/subautofill' | dictionary }} {{ getMobileNumberWithAsterisks(mobileNumber) }}
          </p>
          <code-input
            id="codeInput"
            #codeInput
            [isCodeHidden]="false"
            [isFocusingOnLastByClickIfFilled]="false"
            [disabled]="isLoading"
            [initialFocusField]="0"
            required
            (codeChanged)="onCodeChanged($event)"
            (codeCompleted)="onCodeCompleted($event)"
          >
          </code-input>
          <div class="bl-text-align--center bl-margin-top--24">
            <ng-container *ngIf="errorMessage; else default">
              <p id="getPassCode" aria-live="polite" class="bl-error-msg bl-margin-bottom--0">
                {{ 'personalInfoAutofill/passcodeErrorMessage' | dictionary }}
                <button
                  type="button"
                  id="getNewPasscode"
                  class="bl-font-color--primary bl-text-decoration--underline bl-font-weight--700"
                  (click)="getNewPasscode()"
                >
                  {{ 'personalInfoAutofill/passcodeErrorAction' | dictionary }}
                </button>
              </p>
            </ng-container>
            <ng-template #default>
              <p class="bl-margin-bottom--0">
                {{ 'personalInfoAutofill/passcodeDesc' | dictionary }}
                <button
                  type="button"
                  id="getNewPasscode"
                  class="bl-font-color--primary bl-text-decoration--underline bl-font-weight--700"
                  (click)="getNewPasscode()"
                >
                  {{ 'personalInfoAutofill/retryLink' | dictionary }}
                </button>
              </p>
            </ng-template>
          </div>
          <!-- Info alert -->
          <ea-alert
            [showAlert]="showCodeSentAlert && showNewCodeSentAlert"
            alertId="instatouch-confirm-passcode-alert"
            alertStatus="info"
            [message]="'personalInfoAutofill/newCodeSent' | dictionary"
            [ngClass]="{ 'bl-display--block bl-margin-top--32 bl-max-width--tablet-width': showCodeSentAlert && showNewCodeSentAlert }"
          >
          </ea-alert>
        </div>

        <!-- CTA -->
        <div *ngIf="isLoading" class="loading-bouncing-dots bl-margin-bottom--16">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>

        <div class="bl-margin-x--auto bl-text-align--center" *ngIf="proceedWithoutPhone.observers?.length !== 0">
          <button
            type="button"
            class="bl-button bl-button-reverse bl-width--100"
            id="proceed-without-phone-pre-fill"
            (click)="proceedWithoutPhonePrefill()"
          >
            <span class="bl-white-space--normal">{{ 'personalInfoAutofill/skipPrefill' | dictionary }}</span>
          </button>
          <p class="bl-text-style--default-text-1 bl-margin-top--8 bl-margin-bottom--0">
            {{ 'personalInfoAutofill/Offramp2' | dictionary }}
          </p>
        </div>
      </section>

      <!-- Autofill: Confirm identity stages.identity-->
      <section *ngSwitchCase="stages.identity">
        @if(!isLoading){
        <!-- HEADING -->
        <header
          class="bl-display--flex bl-flex-direction--column bl-text-align--center bl-text-align-sm--left bl-align-items--center bl-margin-bottom--16"
        >
          <ea-svg
            class="bl-text-align--center"
            svgClass="instatouch-id-svg"
            [minWidth]="'52px'"
            [minHeight]="'42px'"
            [width]="'52px'"
            [height]="'42px'"
          >
          </ea-svg>
          <h2 class="bl-text-style--display-3 bl-margin--0 bl-text-align--center bl-padding-x--24">
            {{ 'personalInfoAutofill/identityHeader' | dictionary }}
          </h2>
        </header>

        <!-- CONTENT -->
        <div id="content" class="bl-margin-y--40">
          <!-- Zip code field -->
          <div class="bl-margin-bottom--16">
            <label class="bl-text-style--secondary-text-2 bl-margin-bottom--4 bl-required" for="zipcode">
              {{ getHeadingLabel('zipCode') }}
            </label>
            <input
              class="bl-input bl-width--100"
              id="zipcode"
              data-automation-id="zip-code"
              name="zipcode"
              minlength="5"
              maxlength="5"
              type="tel"
              inputmode="numeric"
              required
              [(ngModel)]="zipCode"
              #zipcode="ngModel"
              [disabled]="isLoading"
              [class.bl-disabled]="isLoading"
              [class.bl-error]="zipcode?.touched && zipcode?.invalid"
              aria-describedby="zipError"
              mask="00000"
            />
            <p
              *ngIf="zipcode?.touched && zipcode?.invalid"
              id="zipError"
              aria-live="polite"
              class="bl-error-msg bl-margin-bottom--0 bl-margin-top--4"
            >
              {{ 'personalInfoAutofill/zipError' | dictionary }}
            </p>
          </div>
          <!-- SSN field -->
          <label class="bl-text-style--secondary-text-2 bl-margin-bottom--4 bl-required" for="ssn">
            {{ getHeadingLabel('ssn') }}
          </label>
          <input
            class="bl-input bl-width--100"
            id="ssn"
            data-automation-id="ssn"
            name="ssn"
            minlength="4"
            maxlength="4"
            type="tel"
            inputmode="numeric"
            required
            [(ngModel)]="ssnNumber"
            #ssn="ngModel"
            [disabled]="isLoading"
            [class.bl-disabled]="isLoading"
            [class.bl-error]="ssn?.touched && ssn?.invalid"
            aria-describedby="ssnError"
            mask="0000"
          />
          <p
            *ngIf="ssn?.touched && ssn?.invalid"
            id="ssnError"
            aria-live="polite"
            class="bl-error-msg bl-margin-bottom--0 bl-margin-top--4"
          >
            {{ 'personalInfoAutofill/ssnError' | dictionary }}
          </p>
          <!-- Error alert -->
          <ea-alert
            [showAlert]="!!errorMessage"
            alertId="instatouch-confirm-identity-alert"
            alertStatus="warning"
            [message]="getIdentityErrorMessage"
            [ngClass]="{ 'bl-display--block bl-margin-top--32 bl-max-width--tablet-width': errorMessage }"
          >
          </ea-alert>
        </div>
        @if(!errorMessage){
        <p class="bl-text-style--secondary-text-1 bl-text-align--center">
          <i class="cu-icons cu-lock bl-margin-right--8 bl-font-size--18"></i> <span [innerHTML]="creditScoreInfo"></span>
        </p>
        }

        <!-- CTA -->
        <ea-button-loader
          buttonType="button"
          buttonId="instatouch-confirm-identity-button"
          buttonClass="bl-width--100 bl-margin-bottom--16"
          [text]="'personalInfoAutofill/continue' | dictionary"
          [loading]="isLoading"
          (event)="emitEvent(instaTouch)"
        >
        </ea-button-loader>
        <div *ngIf="proceedWithoutPhone.observers?.length !== 0" class="bl-margin-x--auto bl-text-align--center">
          <button
            type="button"
            class="bl-button bl-button-reverse bl-width--100"
            id="proceed-without-phone-pre-fill"
            (click)="proceedWithoutPhonePrefill()"
          >
            <span class="bl-white-space--normal">{{ 'personalInfoAutofill/skipPrefill' | dictionary }}</span>
          </button>
          <p class="bl-text-style--default-text-1 bl-margin-top--8 bl-margin-bottom--0">
            {{ 'personalInfoAutofill/Offramp2' | dictionary }}
          </p>
        </div>
        } @else {
        <header class="bl-display-sm--flex bl-text-align--center bl-text-align--center bl-margin-bottom--16 bl-flex-direction--column">
          <h2 class="bl-text-style--display-3 bl-margin--0 bl-text-align--center bl-padding-x-md--24">
            {{ 'personalInfoAutofill/completeHeading' | dictionary }}
          </h2>
        </header>
        <p class="bl-text-style--default-text-1 bl-text-align--center bl-padding-x-md--24 bl-margin-bottom--24">
          {{ 'personalInfoAutofill/completeDesc' | dictionary }}
        </p>
        <ecp-content-spinner class="bl-margin-x--auto bl-margin-y--40 bl-display--block" [spinnerSmall]="true"></ecp-content-spinner>
        <p *ngIf="proceedWithoutPhone.observers?.length !== 0" class="bl-margin-x--auto bl-text-align--center">
          <span class="bl-text-style--default-text-1 bl-margin-bottom--0">{{ 'personalInfoAutofill/tooLong' | dictionary }}</span>
          <button
            type="button"
            class="bl-text-decoration--underline bl-font-color--primary bl-margin-x--4"
            id="proceed-without-phone-pre-fill"
            (click)="proceedWithoutPhonePrefill()"
          >
            <span class="bl-white-space--normal">{{ 'personalInfoAutofill/skipPrefill' | dictionary }}</span>
          </button>
        </p>
        }
      </section>
    </ng-container>
  </form>
</article>